import { map as rxjsmap } from 'rxjs';


import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { AdminUser } from '../models';
import { Options } from './../../../_models/options';
import { ConfigService } from './../../../_services/config.service';
import { BusinessServices } from './../../businesses/services/business.services';
import { BaseServices } from './../../kuba.services';
import { HttpClient, HttpHeaderResponse } from '@angular/common/http';

@Injectable()
export class AdminUserService {
    headers: Headers;
    options: Options;
    private setImagePath = new Subject<any>();
    private setUserProfileImagePath = new Subject<any>();
    private setExistingImagePath = new Subject<any>();
    private checkNewUserOrExisting = new Subject<boolean>();
    private checkExistingUserData = new Subject<boolean>();
    getImage$ = this.setImagePath.asObservable();
    getUserProfileImage$ = this.setUserProfileImagePath.asObservable();
    getExistingImage$ = this.setExistingImagePath.asObservable();
    checkNewUser$ = this.checkNewUserOrExisting.asObservable();
    checkExistingUser$ = this.checkExistingUserData.asObservable();
    constructor(
        private http: HttpClient,
        private userService: BusinessServices
    ) { }

    getImagePath(path: string) {
        this.setImagePath.next(path);
    }

    getUserProfileImagePath(path: string) {
        this.setUserProfileImagePath.next(path);
    }

    getExistingImage(path: string) {
        this.setExistingImagePath.next(path);
    }

    checkNewUser(check: boolean) {
        this.checkNewUserOrExisting.next(check);
    }

    getAllAdminUsers(): Observable<AdminUser[]> {
        return this.http.get<AdminUser[]>(`${environment.BASE_URL}/users`, )
          .pipe(
            map((res: AdminUser[]) => res.filter(x => x.RoleId === ConfigService.ADMIN)),
            catchError(err => throwError(err))
          );
      }

    getAdminUserById(id:any) {
        return this.http.get<any>(environment.BASE_URL + '/admin-user/' + id, ).pipe(rxjsmap((response: any) => {return response}))
    }
    updateAdminUser(id:any, data:any) {
        return this.http.put<HttpHeaderResponse>(environment.BASE_URL + '/admin-user/' + id, data, ).pipe(rxjsmap((response: HttpHeaderResponse) => { return response }));
    }
    updateLanguage(langId:any) {
        return this.http.get(
            environment.BASE_URL + '/user/modify/language/' + langId,
            ).pipe(rxjsmap(result => {
                return result;
            }));
    }
    getByUser(id: number) {
        return this.http.get<HttpHeaderResponse>(environment.BASE_URL + '/user/' + id, )
            .toPromise()
            .then((response: HttpHeaderResponse) => { return response });
    }

    updateUser(id:any, data:any) {
        return this.http.put<HttpHeaderResponse>(environment.BASE_URL + '/user/' + id, data, ).pipe(rxjsmap((response: HttpHeaderResponse) => { return response }));
    }

    getLanguages() {
        return this.http.get(environment.BASE_URL + '/master/languages', ).pipe(rxjsmap(result => result));
    }

    getRoles() {
        return this.http.get<HttpHeaderResponse>(environment.BASE_URL + '/master/roles', )
            .toPromise().then((response: HttpHeaderResponse) => { return response });
    }

    addusers(data:any) {
        return this.http.post<HttpHeaderResponse>(environment.BASE_URL + '/admin-user/', data, ).pipe(rxjsmap((response: HttpHeaderResponse) => { return response }));
    }

    addCountryCode(data:any) {
        return this.http.post<HttpHeaderResponse>(environment.BASE_URL + '/countrycode/countrycode', data, ).pipe(rxjsmap((response: HttpHeaderResponse) => { return response }));
    }
    updateCountryCode(data:any) {
        return this.http.put<HttpHeaderResponse>(environment.BASE_URL + '/countrycode/countrycode', data, ).pipe(rxjsmap((response: HttpHeaderResponse) => { return response }));
    }

    deleteCountryCode(id:any) {
        return this.http.put<HttpHeaderResponse>(environment.BASE_URL + '/countrycode/countrycode/' + id, {}).pipe(rxjsmap((response: HttpHeaderResponse) => { return response }));
    }
    getCountryCodes() {
        return this.http.get<any>(environment.BASE_URL + '/countrycode/countrycodes', ).pipe(rxjsmap(result => result));
    }
    deleteAdminUser(id: number, targetAdminId: number) {
        return this.http.delete<HttpHeaderResponse>(
            `${environment.BASE_URL}/adminuser/${id}?targetAdminId=${targetAdminId}`
        ).pipe(rxjsmap((response: HttpHeaderResponse) => { return response }));
    }
    checkAllocatedCountryCode(code: string) {
        return this.http.get(environment.BASE_URL + '/countrycode/checkexistingcode/' + code, ).pipe(rxjsmap(result => result))
    }
    getAdminCreatedUsers(): Observable<AdminUser[]> {
        return this.http.get<AdminUser[]>(environment.BASE_URL + '/admin-users').pipe(rxjsmap(result => result));
    }
}

